import { lazy } from 'react';

const LazyMainFooter = lazy(() => import('shared/components/main-components/main-footer'));

export default LazyMainFooter;
